/* eslint-disable max-lines */

export const config = {
    name: 'assetHandover-contact',
    selection: true,
    index: false,
    searchFields: [],
    columns: [
        {
            label: '姓名',
            prop: 'contactName',
            width: 200
        },
        {
            label: '客户名称',
            prop: 'customerName',
            width: 200
        },
        {
            label: '职务',
            prop: 'post',
            width: 200
        },
        // {
        //     label: '手机',
        //     prop: 'mobile',
        //     width: 200
        // },
        {
            label: '承接人',
            prop: 'receiverName',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 100,
            fixed: 'right'
        }
    ]
};
